<template>
  <div class="nova-list">
    <div class="filters">
      <div v-for="dFilter in dateFilter" :key="dFilter.key">
        <label
          >{{ dFilter.title }}
          <span
            v-show="params[dFilter.key]"
            @click="params[dFilter.key] = null"
            class="link"
            >{{ "reset" | setText("сбросить") }}</span
          ></label
        >
        <datetime
          v-model="params[dFilter.key]"
          @input="params['page'] = 1"
          class="from-control date-control"
          type="date"
          format="dd/MM/yyyy"
        ></datetime>
      </div>

      <div v-for="f in staticFilters" :key="f.key">
        <nova-select
          :items="f.items"
          class=""
          title="Тип"
          v-model="params[f.key]"
          @change="params['page'] = 1"
        ></nova-select>
        <!-- <label>{{ f.key | setText(f.title) }}</label>
        <select
          @change="params['page'] = 1"
          v-model="params[f.key]"
          class="form-control"
        >
          <option :value="v.id" v-for="(v, vK) in f.items" :key="vK">
            <template v-if="v.key"> {{ v.key | setText(v.title) }}</template>
            <template v-else>{{ v.title }}</template>
          </option>
        </select> -->
      </div>
      <div v-for="filter in filters" :key="filter.key">
        <filter-item
          :modal="filter.key"
          :title="filter.title"
          :single="filter.single"
          :params="filter['params']"
          :titleKey="filter.titleKey"
          v-model="
            params[`${filter.field_key ? filter.field_key : filter.key}_id`]
          "
          @input="params['page'] = 1"
        />
      </div>
    </div>
    <ul v-if="!simple && value.length" class="selected-items">
      <li v-for="v in value" :key="v.id">
        <span>{{ v[checkSelect] }}</span>
        <span @click="clearItem(v.id)"> ✕ </span>
      </li>
    </ul>
    <div
      :class="`${loading ? ' loading' : ''}`"
      class="p-relative nova-list-area"
    >
      <div
        class="nova-list-btns"
        :class="{'empty-status': items.data.length === 0}"
        v-if="
          (value.length && !simple) ||
          isPush ||
          isAdd ||
          setImport === true ||
          is_filter ||
          isUpdate ||
          setImport === true ||
          (functions && functions.length && value.length)
        "
      >
      <svg class="svg-angle" width="25" height="25" viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg"><path d="M0 29V0C0 16.0163 12.9837 29 29 29H0Z"/></svg>
        <!-- <svg xmlns="http://www.w3.org/2000/svg" width="30" height="46" viewBox="0 0 30 46" class="svg-angle">
          <path d="M0.5 45.5V16.5C0.5 32.5163 13.4837 45.5 29.5 45.5H0.5Z"></path>
        </svg> -->
        <div>
          <ul class="status">
            <li v-if="isAdd">
              <button class="btn" @click="addItem">
                <span class="ti-plus"></span>
                {{ "add" | setText("Добавить") }}
              </button>
            </li>
            <li v-if="setImport === true">
              <button class="btn btn-info btn-icon" @click="exportExcel">
                <span class="ti-upload"></span>
                to EXCEL
              </button>
            </li>
            <li v-if="isPush">
              <button
                class="btn btn-info btn-icon"
                @click="$emit('push', true)"
              >
                <span class="ti-plus"></span>
                {{ "push" | setText("Добавить существующего") }}
              </button>
            </li>
            <li v-if="is_filter">
              <button class="btn btn-icon">
                <span class="ti-filter"></span>
                Фильтровать
              </button>
            </li>
            <li v-if="isUpdate">
              <button class="btn btn-warning" @click="getList" id="btn-refresh">
                <span class="ti-reload"></span>
                {{ "update" | setText("Обновить") }}
              </button>
            </li>

            <li v-if="functions && functions.length && value.length">
              <select
                v-model="funcSelected"
                @change="changeFunction"
                class="btn btn-sm btn-select"
                name=""
                id=""
              >
                <option value="0">Действие</option>
                <option
                  v-for="func in functions"
                  :key="func.id"
                  :value="func.id"
                >
                  {{ func.title }}
                </option>
              </select>
            </li>
            <li v-if="value.length && !simple">
              <button class="btn btn-sm btn-warning btn-icon" @click="val = []">
                <span class="ti-close"></span>
                Сброить {{ value.length }}
              </button>
            </li>
          </ul>
        </div>
      </div>
      <div class="p-relative" v-if="columns && columns.length && items">
        <div class="search-cnt">
          <search v-if="searchDisable !== true" v-model="search" />
          <div v-if="items.last_page || searchDisable !== true" class="cnt-title">
            {{ "total" | setText("всего") }} {{ items.total }}
            <svg class="svg-angle svg-angle-right" width="18" height="18" viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg"><path d="M0 29V0C0 16.0163 12.9837 29 29 29H0Z"/></svg>
            <svg class="svg-angle svg-angle-left" width="18" height="18" viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg"><path d="M0 29V0C0 16.0163 12.9837 29 29 29H0Z"/></svg>
          </div>
        </div>
        <nova-close @click="$emit('close')"></nova-close>
        <!-- <span @click="$emit('close')" class="nova-modal-close">
          <div class="__circle"></div>
          <i class="ti-close"></i>
          <svg class="svg-angle svg-angle-left" width="29" height="29" viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg"><path d="M0 29V0C0 16.0163 12.9837 29 29 29H0Z"/></svg>
          <svg class="svg-angle svg-angle-right" width="29" height="29" viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg"><path d="M0 29V0C0 16.0163 12.9837 29 29 29H0Z"/></svg>
        </span> -->
        <template v-if="Object.keys(dataClasses).length && cardLink == 'item_lessonplan_list'">
          <div>
            <tabs 
              :tabs="dataClasses" 
              :active="classesTab" 
              v-model="classesTab"
              class="lessonplan-list-tabs" 
              style="z-index: 19;"/>
            <template v-for="(tab, key) in dataClasses">
              <div v-if="classesTab === key" :key="key">
                <nova-table
                  :holidays="holidays"
                  :additionalId="additionalId"
                  :drag="search ? false : drag"
                  v-show="items.data.length"
                  type="hover"
                  :simple="simple"
                  :items="items"
                  :itemLink="itemLink"
                  :card="cardLink"
                  :cardLink="cardLink"
                  :data="tab.data"
                  @changeData="changeData"
                  :columns="columns"
                  :removeItem="removeItem"
                  v-model="val"
                  :dataObject="dataObject"
                  :current_page="items.current_page"
                  @sortby="sortby"
                ></nova-table>
              </div>
            </template>
          </div>
        </template>
        <template v-else>
          <div class="novatable-responsive">
            <nova-table
              :holidays="holidays"
              :additionalId="additionalId"
              :drag="search ? false : drag"
              v-show="items.data.length"
              type="def"
              :simple="simple"
              :items="items"
              :itemLink="itemLink"
              :card="cardLink"
              :cardLink="cardLink"
              :data="items.data"
              @changeData="changeData"
              :columns="columns"
              :removeItem="removeItem"
              v-model="val"
              :dataObject="dataObject"
              :current_page="items.current_page"
              @sortby="sortby"
            ></nova-table>
            <div class="novatable-wrapper p-y-6" v-if="items.data.length === 0">
              <h4>
                {{ "not_found" | setText("Не найдено (пусто)") }}
              </h4>
            </div>
          </div>
        </template>
      </div>
      <div v-if="items.per_page && items.last_page > 1" class="hide">
        <!--NEW PERPAGE SET-->

        <h5>{{ "on_page" | setText("На странице") }}:</h5>

        <select v-model="items.per_page" @input="setPerPage">
          <option v-for="pP in perPages" :value="pP" :key="pP">
            {{ pP }}
          </option>
        </select>

        <!--NEW-->
      </div>
      <div class="list-bottom">
        <div class="list-pagination" v-show="items.last_page > 1">
          <div>
            <div v-if="items.last_page > 1" class="hide">
              <input
                class="responsive-pagination-input"
                type="number"
                @input="setPage"
              />
            </div>
            <paginate
              v-if="items.last_page"
              v-show="items.last_page > 1"
              :container-class="'pagination-project'"
              :page-range="3"
              v-model="items.current_page"
              :pageCount="items.last_page"
              :prevText="'‹'"
              :nextText="'›'"
            >
            </paginate>
          </div>
        </div>
        <div class="list-bottom-btns">      
          <div class="add-control">
            <svg class="svg-angle svg-angle-right" width="29" height="29" viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg"><path d="M0 29V0C0 16.0163 12.9837 29 29 29H0Z"/></svg>
            <svg class="svg-angle svg-angle-left" width="29" height="29" viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg"><path d="M0 29V0C0 16.0163 12.9837 29 29 29H0Z"/></svg>
            <p-button class="mr-2" round @click.native.prevent="$emit('closeModal')">
              <span class="ti-arrow-left mr-2"></span>Назад
            </p-button>
            <p-button class="" type="info" @click.native.prevent="$emit('accept')">Применить</p-button>
          </div>
        </div>
      </div>
    </div>
    <export-excel
      :exportFields="exportFields"
      :itemLink="itemLink"
      :params="params"
    />
    <add-item
      :openItem="openItem"
      @close="add = false"
      v-if="isAdd && fields && fields.length && setLink && add === true"
      :fieldsFrom="fields"
      :getList="getList"
      :setLink="setLink"
      :cardLink="cardLink"
    />
  </div>
</template>
<script>
import PaperTable from "./PaperTable";
import NovaTable from "./NovaTable";
import Search from "./Search";
import { errorNotify } from "@/plugins/functions";
import { mapState } from "vuex";
export default {
  name: "List",
  data() {
    return {
      add: false,
      classesTab: 0,
      dataClasses: [],
      sort: {
        orderBy: "id",
        orderType: "DESC",
      },
      dataObject: {},
      funcSelected: 0,
      loading: true,
      loadingSearch: false,
      searcher: null,
      search: "",
      items: {
        last_page: 0,
        current_page: 1,
        total: 0,
        per_page: 15,
        data: [],
      },
      holidays: {},
      perPages: [15, 20, 50, 100, 500],
    };
  },
  components: {
    PaperTable,
    NovaTable,
    // AddItem,
    Search,
    "add-item": () => import("./Modals/AddItem"),
    "export-excel": () => import("@/components/ExportExcel"),
  },

  props: {
    openItem: {
      default: true,
    },
    isPush: {
      default: false,
    },
    value: {
      default: function () {
        return [];
      },
    },
    searchDisable: {},
    setLink: {},
    itemLink: {},
    title: {},
    exportFields: {},
    simple: {
      default: false,
    },
    drag: {
      default: false,
    },
    setImport: {
      default: false,
    },
    columns: {},
    removeLink: {},
    cardLink: {},
    modalCreate: {},
    disable_add: {},
    is_filter: {},
    isAdd: {},
    isUpdate: {},
    functions: {},
    fields: {},
    additionalId: {
      default: null,
    },
    params: {
      default: function () {
        return {};
      },
    },
    filters: {
      default: function () {
        return [];
      },
    },
    dateFilter: {
      default: function () {
        return [];
      },
    },
    staticFilters: {
      default: function () {
        return [];
      },
    },
  },
  computed: {
    checkSelect() {
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].checkbox === true) {
          return this.columns[i].key;
        }
      }
      return null;
    },
    ...mapState(["newOrder", "lastUpdate"]),
    page() {
      return this.items.current_page;
    },
    val: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    newOrder(val) {
      if (val && this.cardLink === "orders") {
        this.getList(false);
      }
    },
    page(val) {
      if (val) {
        window.scrollTo({ top: 0, behavior: "smooth" });
        setTimeout(() => {
          this.getList();
        }, 100);
      }
    },
    search() {
      this.items.current_page = 1;
      this.loadingSearch = true;
      this.loading = true;
      clearTimeout(this.searcher);
      this.searcher = setTimeout(() => {
        this.getList(false);
      }, 1000);
    },
    lastUpdate(val) {
      if (val) {
        this.getList();
      }
    },
    params: {
      handler: function (val) {
        window.scrollTo({ top: 0, behavior: "smooth" });
        this.items.current_page = val.page;
        setTimeout(() => {
          this.getList();
        }, 100);
      },
      deep: true,
    },
  },
  methods: {
    setPage(event) {
      clearTimeout(this.searcher);
      this.searcher = setTimeout(() => {
        let page = event.target.value;
        this.items.current_page = parseInt(page);
      }, 600);
    },
    exportExcel() {
      this.$modal.show("export");
    },
    changeData(val) {
      this.items.data = val;
    },
    sortby(val) {
      this.sort = val;
      this.getList();
    },
    addItem() {
      this.add = true;
    },
    changeFunction(val) {
      this.$emit("changeFunction", this.funcSelected);
      this.funcSelected = 0;
    },
    removeItem(itemID) {
      this.$dialog
        .confirm("Вы точно хотите удалить?", {
          okText: "Удалить",
          cancelText: "Отмена",
        })
        .then(() => {
          this.$loading(true);


          this.$http
            .post(`${this.itemLink}/${itemID}`, { _method: "DELETE" })
            .then((response) => {
              this.getList();
            })
            .catch((error) => {
              errorNotify(error, this.$notify);
            })
            .finally(() => {
              setTimeout(() => {
                this.$loading(false);
              }, 400);
            });
        })
        .catch(() => {});
    },
    getList(loading = true, resetPage = false) {
      let params = this.params ? this.params : {};

      params["page"] = this.items.current_page;
      params["per_page"] = this.items.per_page;
      params["search"] = this.search;
      
      if (!params["order"])
        params["order"] = `${this.sort.orderType === "DESC" ? "" : "-"}${
          this.sort.orderBy
        }`;

      this.loading = true;
      if (loading) {
        this.$loading(true);
      }
      if (resetPage === true) {
        params["page"] = 1;
      }

      if (this.$store.state.business) {
        params.business_id = this.$store.state.business.id;
      }

      this.$http
        .get(this.itemLink, {
          params: params,
        })
        .then((response) => {
          if (response.data.data) {
            this.items.data = response.data.data;
            if (response.data.holidays) {
              this.holidays = response.data.holidays;
            }
            if(response.data.meta){
              this.items.total = response.data.meta.total;
              const perPage = response.data.meta.per_page;
              this.items.per_page = perPage;
              this.items.last_page = Math.ceil(this.items.total / perPage);
            }
            let data = response.data.data;
            for (let i = 0; i < this.value.length; i++) {
              this.dataObject[this.value[i].id] = this.value[i];
            }
            for (let i = 0; i < data.length; i++) {
              this.dataObject[data[i].id] = data[i];
            }
            let courses = {}
            this.dataClasses = []
            this.classesTab = 0
            for (let i = 0; i < data.length; i++) {
              if(!data[i].course)
                continue
              if(!courses[data[i].course.position])
                courses[data[i].course.position] = [];    
              courses[data[i].course.position].push(data[i]);
            }
            for (const i in courses) {
              if (Object.hasOwnProperty.call(courses, i)) {
                this.dataClasses.push({
                  title: `Класс ${i}`,
                  data: courses[i]
                })
              }
            }
          }else{
            if(this.itemLink == 'system'){
              let courses = []
              for (const key in response.data.courses) {
                if (Object.hasOwnProperty.call(response.data.courses, key)) {
                  const element = response.data.courses[key]; 
                  courses.push({id: element, position: key, title: key})
                }
              }
              for (let i = 0; i < this.value.length; i++) {
                this.dataObject[this.value[i].id] = this.value[i];
              }
              for (let i = 0; i < courses.length; i++) {
                this.dataObject[courses[i].id] = courses[i];
              }
              this.items.data = courses
            }
          }
          if (response.data.type) {
            this.$emit("type", response.data.type);
          }
          
          this.$emit("succress", true);
        })
        .catch((error) => {
          console.log(error, 'error')
          this.$emit("error", true);
          this.items.last_page = 1;
        })
        .finally(() => {
          setTimeout(() => {
            this.$loading(false);
            this.loading = false;
          }, 400);
        });
    },

    clearItem(id) {
      this.val = [...this.val].filter((item) => {
        return item.id != id;
      });
    },
    setPerPage(event) {
      this.items.current_page = 1;
      setTimeout(() => {
        this.getList();
      }, 10);
    },
  },
  mounted() {
    console.log(this.value, 'value')
    this.getList();
  },
};
</script>
<style lang="scss">
@keyframes identifier {
  0%{
    height: 0;
    opacity: 0;
  }
  100%{
    opacity: 1;
    height: 27px;
  }
}
ul.selected-items {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  // overflow-x: auto;
  justify-content: center;
  // background-color: white;
  border-radius: 30px;
  padding: 5px;
  // border: 5px solid #d3d3d3;
  max-width: 100%;
  margin-bottom: 15px;
  margin-top: -15px;
  perspective: 200px;
  perspective-origin: 50% 100%;
  @media (min-width: 769px) {
    flex-wrap: wrap;
  }

  & > li {
    max-width: 180px;
    border-radius: 30px 40%;
    margin-right: 10px;
    background-color: #464646;
    color: white;
    font-size: 13px;
    margin-bottom: 0;
    margin-right: 0;
    padding: 0 10px;
    padding-left: 15px;
    display: flex;
    align-items: center;
    position: relative;
    transform: rotateX(4deg);
    transition: 0.5s ease;
    animation: identifier 0.3s ease 0s 1;
    height: 27px;
    // &:nth-child(5n+1){ background-color: #271b8f; }
    // &:nth-child(5n+2){ background-color: #ff4c00; }
    // &:nth-child(5n+3){ background-color: #ff961d; }
    // &:nth-child(5n+4){ background-color: #30ab02; }
    // &:nth-child(5n+5){ background-color: #eb265d; }
    &:nth-child(4) ~ li:not(:nth-last-child(4) ~ li){ transform: rotateX(3deg); }
    //&:nth-last-child(4) ~ li{ transform: rotateX(0deg); }


    &:hover{
      cursor: pointer;
      &:nth-child(5n+1){ background-color: #271b8f; }
      &:nth-child(5n+2){ background-color: #ff4c00; }
      &:nth-child(5n+3){ background-color: #ff961d; }
      &:nth-child(5n+4){ background-color: #30ab02; }
      &:nth-child(5n+5){ background-color: #eb265d; }
      & > span:last-child{
        opacity: 1;
      }
    }
     svg{
      position: absolute;
      fill: white;
      z-index: -1;
      border-radius: 50%;
      left: 0px;
      top: 0px;
      width: 20px;
      height: 20px;
     }
    & > span {
      &:nth-child(1){
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 150px;
      }
      &:last-child {
        font-size: 12px;
        margin-left: 4px;
        cursor: pointer;
        opacity: 0;
        &:hover {
          opacity: 0.6;
        }
      }
    }
  }
}
</style>
